// extracted by mini-css-extract-plugin
export var header = "_ui-1";
export var maskBottom = "_ui-6";
export var maskMiddle = "_ui-7";
export var maskTop = "_ui-5";
export var root = "_ui-0";
export var scrollDownButton = "_ui-3";
export var scrollDownButtonHidden = "_ui-4";
export var viewport = "_ui-2";